import { createContext, useContext } from 'react'

/**
 * Context
 */

type Props = {
  registerCheckbox: (field: string) => void
}

export const CheckboxGroupContext = createContext<Props | null>(null)

/**
 * Hook
 */

export const useCheckboxGroupControl = () => useContext(CheckboxGroupContext)
